import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import App from './App.vue';
import { AppInsightsPlugin, IAppInsightsOptions } from './plugins/appinsights-vue';

Vue.config.productionTip = false;
Vue.use<IAppInsightsOptions>(AppInsightsPlugin, process.env.VUE_APP_APPINSIGHTS_KEY ? {
    instrumentationKey: process.env.VUE_APP_APPINSIGHTS_KEY,
} : undefined);

new Vue({
  render: (h) => h(App),
}).$mount('#app');
